import React from 'react';
import styled from 'styled-components';
import { getUserRights } from "../../api";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { LoginContext } from "../login/context/LoginContext";
import { TailwindWrapper } from '@utils/TailwindWrapper';
import { TreebulaIcon } from '@ui-component-library/components/Icon/lib';
import { Icon, Text, Button, Link } from '@ui-component-library';

class Navigation extends React.Component {
    static contextType = LoginContext;

    constructor() {
        super();

        this.state = {
            isLogged: Window.user_data.isLogged,
            isAdmin: Window.user_data.isAdmin,
            userRoles: Window.user_data.roles,
            showMobileMenu: false,
            dropdownTop: null,
            mobileDropdownOpen: []
        }
        this.navbarRef = React.createRef()
    }

    updateNavbar() {
        getUserRights().then(resp => {
            if (resp.ok) {
                resp.json().then((json) => {
                    this.setState({ isLogged: json.is_login, userRoles: json.roles, isAdmin: json.is_admin })
                })
            } else {
                alert('Oops something went wrong')
            }
        })
    }

    // When the component is mounted, observe the body for class changes to update the navbar
    componentDidMount() {
        // Use the line below to update the navbar in other components:
        // document.getElementsByTagName('body')[0].classList.toggle("nav-update")

        this.observer = new MutationObserver(record => {
            record.forEach((event) => {
                if (event.attributeName == 'class') {
                    this.updateNavbar(); // Trigger update when class changes
                }
            })
        })

        this.observer.observe(document.getElementsByTagName('body')[0], { attributes: true })
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    // Toggle the active dropdown menu
    setActiveMenu(name) {
        const closing = this.state.dropdown === name
        const top = closing ? null : (this.navbarRef.current?.getBoundingClientRect?.()?.bottom ?? null)
        this.setState({ dropdown: closing ? false : name, dropdownTop: top })
    }

    toggleMobileDropdown(name) {
        this.setState((prev) => {
            const open = prev.mobileDropdownOpen.includes(name)
                ? prev.mobileDropdownOpen.filter((n) => n !== name)
                : [...prev.mobileDropdownOpen, name];
            return { mobileDropdownOpen: open };
        });
    }

    userAccountButtons(size = 'md') {
        const LoginContext = this.context;
        const sizes = {
            md: {
                icon: '24px',
                div: '50px'
            },
            sm: {
                icon: '18px',
                div: '32px'
            }
        }

        return <>
            {this.state.isAdmin && <div className="d-flex justify-content-center align-items-center border border-1 border-charcoal-500 rounded rounded-circle bg-charcoal-500 me-1" style={{ height: sizes[size].div, width: sizes[size].div, cursor: "pointer" }} onClick={() => window.open('/vb-admin/', '_blank')}>
                <img className='primary-core-filter mb-1' src={`${Window.static_path}img/treebula/icon.svg`} alt="admin icon" height={sizes[size].icon} width={sizes[size].icon} />
            </div>}

            <div className={`d-flex justify-content-center align-items-center border border-1 border-charcoal-500 rounded rounded-circle ${this.state.isLogged ? 'bg-charcoal-500' : 'hover-bg-cloud-500'}`} style={{ height: sizes[size].div, width: sizes[size].div, cursor: "pointer" }} onClick={() => LoginContext.isLogged ? window.open('/min-skog/', '_self') : LoginContext.setShow(true)}>
                <img className={`${this.state.isLogged ? 'primary-core-filter' : ''}`} src={`${Window.static_path}img/icons/user-outline.svg`} alt="user icon" height={sizes[size].icon} width={sizes[size].icon} />
            </div>

        </>
    }

    checkVisible(i, jsx) {
        const { userData } = this.context;

        if (i.visible == 'NO_USER' && userData.is_logged) {
            return null
        }

        if (i.visible == 'ONLY_LOGGED' && !userData.is_logged) {
            return null
        }

        if (i.visible == 'ONLY_PLUS' && !userData.is_plus) {
            return null
        }

        if (i.visible == 'NOT_PLUS' && userData.is_plus) {
            return null
        }

        if (i.visible == 'LOGGED_NOT_PLUS' && (!userData.is_logged || userData.is_plus)) {
            return null
        }

        return jsx
    }

    render() {

        const loginContext = this.context;
        return <>
            {/* Overlay for the dropdown, hidden unless a dropdown is active */}
            <div className="position-sticky top-0" style={{ zIndex: 1040 }}>
                <TailwindWrapper>
                    {this.state.dropdown && <div className="hidden xl:block fixed inset-0 bg-transparent z-[var(--z-nav-overlay)]" onClick={() => { this.setState({ dropdown: false, dropdownTop: null }) }}>
                    </div>}
                    {/* Single blurred layer for navbar + dropdown (z-[1071]); solid bg when mobile menu open */}
                    <div
                        className={`relative z-[var(--z-nav-bar)] w-full ${this.state.showMobileMenu ? 'bg-[#0A0A0A]' : 'bg-[#0A0A0A]/80 backdrop-blur-[32px]'}`}
                        style={this.state.dropdown ? { minHeight: '480px' } : undefined}
                    >
                        <div>
                            <div className='max-w-[1320px] mx-auto py-4 gap-2 flex items-center justify-between px-4'>
                                <div className='flex items-center'>
                                    <a
                                        className='flex items-center gap-2 cursor-pointer no-underline mr-8'
                                        href="/"
                                    >
                                        <Icon tw name='TreebulaIcon' size="xlarge" className="fill-[#DFFF5D]" />
                                        <Text tw variant="text-2xl/leading-none/extrabold" className='text-[#DFFF5D]'>
                                            Treebula
                                        </Text>
                                    </a>
                                    <div className="hidden xl:block">
                                        <div className="relative w-full z-[var(--z-nav-links)]" ref={this.navbarRef}>
                                            <div className="flex items-center relative z-[var(--z-nav-items)]">
                                                {Window.navbar_data.map(i => {
                                                    if (i.url != 'dropdown') {
                                                        return this.checkVisible(i,
                                                            <Text variant="text-sm/leading-normal/medium" key={i.label}>
                                                                <Link
                                                                    tw
                                                                    href={(this.state.isLogged && i.logged_in_url) ? i.logged_in_url : i.url}
                                                                    className="text-cloud-200 hover:text-cloud-300 no-underline hover:bg-[rgba(255,255,255,0.08)] hover:no-underline rounded-lg px-4 py-3"
                                                                >
                                                                    {i.label}
                                                                </Link>
                                                            </Text>
                                                        )
                                                    } else {
                                                        return this.checkVisible(i,
                                                            <Button
                                                                tw
                                                                variant='tertiary'
                                                                size="medium"
                                                                key={i.name}
                                                                className="text-cloud-200 hover:bg-[rgba(255,255,255,0.08)]"
                                                                onClick={() => this.setActiveMenu(i.name)}
                                                            >
                                                                {i.label}
                                                                <Icon
                                                                    tw
                                                                    name="ChevronDownSimple"
                                                                    size="medium"
                                                                    className={`fill-cloud-200 pointer-events-none ${this.state.dropdown == i.name ? 'rotate-180' : ''} transition-transform duration-150`}
                                                                    aria-hidden
                                                                />
                                                            </Button>
                                                        )
                                                    }
                                                })}
                                            </div>
                                            {Window.navbar_data.map((i) => {
                                                if (i.url === 'dropdown' && i.content) {
                                                    return (
                                                        <React.Fragment key={i.name} >
                                                            {this.state.dropdown === i.name && this.state.dropdownTop != null && (
                                                                <div
                                                                    className="hidden xl:block fixed left-0 right-0 z-[var(--z-nav-dropdown-area)] mt-4 bg-transparent"
                                                                    style={{ top: this.state.dropdownTop, minHeight: '380px' }}
                                                                />
                                                            )}
                                                            <div className={`absolute top-full left-0 z-[var(--z-nav-links)] py-6 w-[720px] ${this.state.dropdown === i.name ? "xl:block" : "hidden"}`}>
                                                                <div className="grid grid-cols-2 gap-4">
                                                                    <div className="flex flex-col">
                                                                        {i.content.items.filter(link => link.column != 2).map((link) => {
                                                                            return this.checkVisible(link, (
                                                                                <Link key={link.label} tw href={(this.state.isLogged && link.logged_in_url) ? link.logged_in_url : link.url} className="flex flex-col flex-nowrap p-4 my-1 rounded-lg hover:bg-[rgba(255,255,255,0.08)] w-full no-underline hover:no-underline text-inherit">
                                                                                    <div className="flex items-center">
                                                                                        <Text tw variant="text-base/leading-normal/medium" className="text-cloud-200 mr-3 hover:text-cloud-300">
                                                                                            {link.label}
                                                                                        </Text>
                                                                                        {link.icon && <Icon tw name={link.icon} size="medium" className="fill-cloud-200 shrink-0 ml-auto " />}
                                                                                    </div>
                                                                                    <div>
                                                                                        <Text tw variant="text-sm/leading-normal/normal" className='text-cloud-400 truncate'>{link.subText}</Text>
                                                                                    </div>
                                                                                </Link>
                                                                            ))
                                                                        })}
                                                                    </div>
                                                                    <div className="flex flex-col">
                                                                        {i.content.items.filter(link => link.column == 2).map((link) => this.checkVisible(link, (
                                                                            <Link key={link.label} tw href={(this.state.isLogged && link.logged_in_url) ? link.logged_in_url : link.url} className="flex flex-col flex-nowrap p-4 my-1 rounded-lg hover:bg-[rgba(255,255,255,0.08)] w-full no-underline hover:no-underline text-inherit">
                                                                                <div className="flex items-center">
                                                                                    <Text tw variant="text-base/leading-normal/medium" className="text-cloud-200 mr-3 hover:text-cloud-300">
                                                                                        {link.label}
                                                                                    </Text>
                                                                                    {link.icon && <Icon tw name={link.icon} size="medium" className="fill-cloud-200 shrink-0 ml-auto " />}
                                                                                </div>
                                                                                <div>
                                                                                    <Text tw variant="text-sm/leading-normal/normal" className="text-cloud-400 truncate">{link.subText}</Text>
                                                                                </div>
                                                                            </Link>
                                                                        )))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className='flex items-center gap-4'>
                                    <div className="hidden md:flex items-center gap-2 sm:gap-4">
                                        <Button
                                            tw
                                            variant='tertiary'
                                            size="medium"
                                            onClick={() => { window.open('/min-skog/demo/', '_self'); }}
                                            className={
                                                loginContext.isLogged
                                                    ? 'text-cloud-200 bg-[#515151] hover:bg-[rgba(255,255,255,0.12)]'
                                                    : 'text-cloud-200 hover:bg-[rgba(255,255,255,0.08)]'
                                            }
                                        >
                                            Prova demo
                                        </Button>
                                        {this.state.isAdmin && <Button tw variant='tertiary' size="medium" className='text-[#ECFF8C] bg-[#4E5431]' onClick={() => window.open('/vb-admin/', '_blank')}>Admin</Button>}
                                        {!this.state.isAdmin && !this.state.isLogged && <Button tw variant='tertiary' size="medium" className="text-cloud-200 bg-[#515151]" onClick={() => { if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>Kom igång</Button>}
                                        {!this.state.isLogged ? (
                                            <Button tw variant='tertiary' size="medium" className="bg-[#DFFF5D] text-#0F0F0F hover:bg-[rgba(255,255,255,0.08)]" onClick={() => { if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>
                                                <Icon tw name="BankIdSimple" size="medium" className='fill-#0F0F0F' />
                                                Logga in
                                            </Button>
                                        ) : <Button tw variant='tertiary' size="medium" className='text-[#ECFF8C] bg-[#0A0A0A]/50' onClick={() => { if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>
                                            Min skog
                                            <Icon tw name="ArrowRightSimple" size="medium" className='fill-[#ECFF8C]' />
                                        </Button>}
                                    </div>
                                    <Button tw variant='tertiary' className="xl:hidden flex items-center justify-center rounded-lg -mr-2.5 p-3 text-cloud-200 hover:bg-[rgba(255,255,255,0.08)]" onClick={() => this.setState({ showMobileMenu: !this.state.showMobileMenu, mobileDropdownOpen: [] })} aria-label={this.state.showMobileMenu ? 'Stäng meny' : 'Öppna meny'}>
                                        {this.state.showMobileMenu ? (
                                            <Icon tw name="CrossSimple" size="large" className="fill-cloud-200" />
                                        ) : (
                                            <Icon tw name="HamburgerMenu" size="large" className="fill-cloud-200 " />
                                        )}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </TailwindWrapper >
            </div >

            <Offcanvas show={this.state.showMobileMenu} placement="top" className="border-0 navbar-mega-menu-fullscreen" style={{ background: '#0A0A0A' }}>
                <TailwindWrapper>
                    <div className="flex flex-col w-full min-h-dvh h-full bg-[#22252A]" >
                        <div className="flex justify-between items-center px-4 py-4 w-full">
                            <a href="/" className="flex items-center gap-2 no-underline" onClick={() => this.setState({ showMobileMenu: false })}>
                                <Icon tw name="TreebulaIcon" size="xlarge" className="fill-[#DFFF5D]" />
                                <Text tw variant="text-2xl/leading-none/extrabold" className="text-[#DFFF5D]">Treebula</Text>
                            </a>
                            <Button tw variant='tertiary' className="p-2 rounded-lg text-cloud-200 hover:bg-[rgba(255,255,255,0.08)]" onClick={() => this.setState({ showMobileMenu: false })} aria-label="Stäng meny">
                                <Icon tw name="CrossSimple" size="large" className="fill-cloud-200" />
                            </Button>
                        </div>
                        <div className="flex-1 flex flex-col min-h-0">
                            <div className="flex-1 overflow-auto px-4 py-4">
                                
                                {Window.navbar_data.map(i => {
                                    if (i.url !== 'dropdown' || !i.content || !i.content.items) return null;
                                    const col1 = i.content.items.filter(link => link.column != 2);
                                    const col2 = i.content.items.filter(link => link.column == 2);
                                    const itemBlock = (link) => (
                                        <div key={link.label} className="rounded-xl flex flex-col px-2">
                                            <Link
                                                tw
                                                href={(this.state.isLogged && link.logged_in_url) ? link.logged_in_url : link.url}
                                                className="flex items-center flex-nowrap p-6 rounded-lg hover:bg-[rgba(255,255,255,0.08)] hover:text-[#D5EE64] w-full text-cloud-200 no-underline  hover:no-underline"
                                                onClick={() => this.setState({ showMobileMenu: false })}
                                            >
                                                <Text tw variant="text-base/leading-normal/medium" className="min-w-0 flex-1">
                                                    {link.label}
                                                </Text>
                                                {link.icon && <Icon tw name={link.icon} size="medium" className="fill-cloud-200 shrink-0 ml-2" />}
                                            </Link>
                                            {link.content && (
                                                <Text tw variant="text-sm/leading-normal/normal" className="text-cloud-400 pl-2">
                                                    {link.content}
                                                </Text>
                                            )}
                                        </div>
                                    );
                                    const isOpen = this.state.mobileDropdownOpen.includes(i.name);
                                    return (
                                        <div key={i.name}>
                                            {/* Mobile only: clickable header to expand/collapse */}
                                            <div
                                                role="button"
                                                tabIndex={0}
                                                className="flex md:hidden items-center justify-between cursor-pointer py-1 p-4 rounded-lg hover:bg-white/5"
                                                onClick={() => this.toggleMobileDropdown(i.name)}
                                                onKeyDown={(e) => e.key === 'Enter' && this.toggleMobileDropdown(i.name)}
                                                aria-expanded={isOpen}
                                                aria-label={`${i.label}, ${isOpen ? 'stäng' : 'öppna'}`}
                                            >
                                                <h4 className={`text-base font-medium p-4 ${isOpen ? 'text-cloud-200' : 'text-cloud-200/80'}`} >{i.label}</h4>
                                                <Icon tw name="ChevronDownSimple" size="medium" className={`fill-cloud-200/80 transition-transform duration-150 ${isOpen ? 'rotate-180 text-cloud-200' : ''}`} aria-hidden />
                                            </div>
                                            {/* md+: static header, no chevron, aligned with parent */}
                                            <div className="hidden md:block px-8">
                                                <Text variant='text-xs/leading-normal/medium' className="text-[#DDDDDD]">{i.label}</Text>
                                            </div>
                                            {/* Mobile: grid only when open. md+: grid always visible */}
                                            <div className={`grid-cols-1 sm:grid-cols-2 gap-4 ${isOpen ? 'grid' : 'hidden md:grid'}`}>
                                                <div className="flex flex-col">
                                                    {col1.map(link => this.checkVisible(link, itemBlock(link)))}
                                                </div>
                                                <div className="flex flex-col">
                                                    {col2.map(link => this.checkVisible(link, itemBlock(link)))}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                {Window.navbar_data.filter(i => i.url !== 'dropdown').map(i => this.checkVisible(i,
                                    <div key={i.label} className="rounded-xl max-w-[480px] px-2">
                                        <Link
                                            tw
                                            href={(this.state.isLogged && i.logged_in_url) ? i.logged_in_url : i.url}
                                            className="text-cloud-200/80 no-underline hover:no-underline block p-6 rounded-lg hover:text-[#D5EE64] hover:bg-[rgba(255,255,255,0.08)]"
                                            onClick={() => this.setState({ showMobileMenu: false })}
                                        >
                                            <Text tw variant="text-base/leading-normal/medium">{i.label}</Text>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                            <div className="flex gap-3 px-4 py-4 border-t border-white/10 shrink-0">
                                {!this.state.isLogged ? (
                                    <Button tw variant="secondary" size="medium" className="flex-1 text-cloud-200 bg-cloud-200/30 justify-center gap-2" onClick={() => { this.setState({ showMobileMenu: false }); if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>
                                        <Icon tw name="BankIdSimple" size="large" className="fill-cloud-200" />
                                        Logga in
                                    </Button>
                                ) : (<Button tw variant="tertiary" size="medium" className="flex-1 text-cloud-200 bg-[#515151] justify-center gap-2" onClick={() => { this.setState({ showMobileMenu: false }); if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>
                                    Logga ut
                                </Button>)
                                }
                                {!this.state.isLogged ? (
                                    <Button tw variant="secondary" size="medium" className="flex-1 bg-[#D5EE64] text-[#0F0F0F] justify-center" onClick={() => { window.open('/min-skog/demo/', '_self'); }}>
                                        Prova demo
                                    </Button>
                                ) : (<Button tw variant="tertiary" size="medium" className="flex-1 justify-center text-[#ECFF8C] bg-[#0A0A0A]/50 " onClick={() => { if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>Min skog <Icon tw name="ArrowRightSimple" size="medium" className='fill-[#ECFF8C]' /></Button>)}
                            </div>
                        </div>
                    </div>
                </TailwindWrapper>
            </Offcanvas>
        </>
    }
}

export default Navigation;